export default __webpack_public_path__ + "static/media/hat.2c8d3b8b.svg";